import { FC } from 'react'

import { ASSET_TYPE_LABELS } from '@/core/modules/digital-footprint/assets/constants'
import { formatDate } from '@core/utils/time'
import { DetailsGrid } from '@ui/drawer/common/DetailsGrid'
import { InfoItem } from '@ui/drawer/common/infoItem'

type TAssetInfoProps = {
    asset: TAsset
}

const AssetCloudAppInfo: FC<TAssetInfoProps> = ({ asset }) => {
    const { asset_type: assetType, provider_name, last_seen } = asset

    return (
        <DetailsGrid dataTestId="cloud-app-details-grid">
            <InfoItem title="Asset Type" dataTestId={`asset-type-${assetType}`}>
                {ASSET_TYPE_LABELS[assetType]}
            </InfoItem>
            <InfoItem title="Last Scan Date" dataTestId="last-scan-date">
                {last_seen ? formatDate(last_seen) : '-'}
            </InfoItem>
            <InfoItem title="Service" dataTestId="provider-name">
                {provider_name || '-'}
            </InfoItem>
        </DetailsGrid>
    )
}

export default AssetCloudAppInfo
